import type { MeetingInfo } from '../types/meeting';

export function isCateringOrderAllowed(meeting: MeetingInfo | null): boolean {
  return Boolean(meeting && meeting.isOrganizer && !meeting.isPastMeeting);
}
